import _ from 'lodash'

import {
  TOGGLE_ACCOMMODATION_MODAL
} from '../actions/toggleAccommodationModal'

const initialState = {
  isOpen: false,
  windowOffset: 0,
}

export default function fetchConfiguration(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_ACCOMMODATION_MODAL:
      return {
        isOpen: !state.isOpen,
        windowOffset: action.payload || state.windowOffset,
      }
    default:
      return state
  }
}

export const getIsAccommodationModalOpen = state => _.get(state, 'accommodationModalData.isOpen')
export const getAccommodationModalWindowOffset = state => _.get(state, 'accommodationModalData.windowOffset')
